import { motion, useReducedMotion } from 'framer-motion';
import { EASE, fadeUpItem, staggerParent } from '@/animations/variants';
import { Reveal } from '@/components/ui/Reveal';

export default function AboutSection() {
  const reduce = useReducedMotion();

  return (
    <section
      id="about"
      className="py-20 sm:py-28 lg:py-36 bg-cream"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
        <Reveal variants={staggerParent}>

          <motion.p className="section-label mb-6" variants={fadeUpItem}>私たちの想い</motion.p>

          <motion.h2
            className="font-serif-jp text-deep-brown text-xl sm:text-2xl lg:text-3xl leading-relaxed mb-8"
            variants={fadeUpItem}
          >
            日々の疲れをリセットし、<br className="sm:hidden" />
            心身のバランスを整える。
          </motion.h2>

          <motion.p
            className="font-sans-jp text-earth/85 text-sm text-left leading-loose max-w-2xl mx-auto mb-6"
            variants={fadeUpItem}
          >
            大阪・天満の静かな一角に佇む、ほぐし屋さん Luminosite。
            肩甲骨はがしを中心とした熟練の手技で、
            あなたの身体のコリと疲れを丁寧にほぐしていきます。
            自然素材のオイルと落ち着いた空間で、
            特別な癒しの時間をご提供いたします。
          </motion.p>

          <motion.p className="font-serif-jp text-earth text-sm tracking-wider" variants={fadeUpItem}>
            〜 ほぐし屋さん 〜
          </motion.p>
        </Reveal>
      </div>
    </section>
  );
}